/**
 * REST feedback endpoint.
 *   POST /feedback — submit app feedback (star rating + optional suggestion/message)
 */
import { z } from 'zod';
import { UuidSchema } from '../common/id.js';
import { Iso8601Schema } from '../common/timestamp.js';
export const FeedbackCreateBody = z
    .object({
    rating: z.number().int().min(1).max(5),
    suggestion: z.string().max(2000).optional(),
    message: z.string().max(4000).optional(),
})
    .strict();
export const FeedbackCreateResponse = z.object({
    id: UuidSchema,
    createdAt: Iso8601Schema,
});
//# sourceMappingURL=feedback.js.map